<form [formGroup]="commReconForm">
    <modal-panel title="Apply Commission Reconciliation" data-testid="comm-recon-form-modal" class="modal-panel filter-panel" (close)="onCancel()">
      <div mat-dialog-content data-testid="comm-recon-form-modal-confirm-popup" class="confirmpopup">
          <div mat-dialog-title>
            <mat-label class="title">You selected {{ serviceData.checkedCount }} record{{ serviceData.checkedCount > 1 ? "s" : "" }}. Please, select a bank.</mat-label>
          </div>
          <mat-form-field>
            <mat-label>Bank</mat-label>
            <input type="text" matInput formControlName="bank" [matAutocomplete]="bankAuto">
            <mat-autocomplete #bankAuto="matAutocomplete" [displayWith]="displayWithBank">
                @for (bank of filteredBank$ | async; track bank?.id) {
                    <mat-option [value]="bank">{{bank?.name}}</mat-option>
                }
            </mat-autocomplete>
            @if(commReconForm.controls['bank'].value){
                <button data-testid="comm-recon-form-modal-bank-clear-button" matSuffix mat-icon-button type="button" (click)="clearFields('bank')">
                  <mat-icon>close</mat-icon>
                </button>
            }
          </mat-form-field>
          <ng-container modalPanelFooter>
            <div mat-dialog-actions align="end">
              <button data-testid="comm-recon-form-modal-confirm-button" type="submit" mat-raised-button (click)="onConfirm()" color="primary" matTooltip="Confirm" [disabled]="commReconForm.invalid">
                <mat-spinner id="delete-vcc-dialog-spinner" color="accent" *ngIf="isLoadingSpinner"diameter="30"></mat-spinner>
                <span *ngIf="!isLoadingSpinner">Ok</span>
              </button>
              <button data-testid="comm-recon-form-modal-cancel-button" mat-raised-button (click)="onCancel()" color="warn" matTooltip="Cancel and Close">
                No Thanks
              </button>
            </div>
          </ng-container>
        </div>
  </modal-panel>
</form>
